(() => {
  const SWATCH_SELECTOR = '[data-option-type="color"][data-value]';
  const SPLIT_ANGLE = '135deg';
  const separators = [
    /\s*\/\s*/,
    /\s*\+\s*/,
    /\s+(?:&|y|and)\s+/i,
    /\s+-\s+/
  ];

  const normalize = (value) => value.trim().toLowerCase();

  function getSplitParts(value) {
    for (const separator of separators) {
      const parts = value.split(separator).map((part) => part.trim()).filter(Boolean);

      if (parts.length === 2) return parts;
    }

    return null;
  }

  function getConfiguredColor(value) {
    const normalizedValue = normalize(value);
    const color = (window.MinimogSettings?._colorSwatches || []).find(
      (swatch) => swatch.key === normalizedValue
    )?.value;
    const resolvedColor = color || value.trim();

    return CSS.supports('color', resolvedColor) ? resolvedColor : null;
  }

  function hasExactSwatch(value) {
    const normalizedValue = normalize(value);
    const settings = window.MinimogSettings || {};

    return [...(settings._colorSwatches || []), ...(settings._imageSwatches || [])].some(
      (swatch) => swatch.key === normalizedValue
    );
  }

  function getSplitBackground(value) {
    if (!value || hasExactSwatch(value)) return null;

    const parts = getSplitParts(value);
    if (!parts) return null;

    const colors = parts.map(getConfiguredColor);
    if (colors.some((color) => !color)) return null;

    return `linear-gradient(${SPLIT_ANGLE}, ${colors[0]} 0 50%, ${colors[1]} 50% 100%)`;
  }

  function applySplitSwatch(node) {
    if (node.dataset.splitSwatchProcessed === 'true') return;

    const label = node.matches('.m-product-option--node__label')
      ? node
      : node.querySelector('.m-product-option--node__label');
    const background = getSplitBackground(node.dataset.value);

    node.dataset.splitSwatchProcessed = 'true';

    if (!label || !background) return;

    label.classList.add('m-product-option--split-swatch');
    label.style.setProperty('--m-split-swatch-background', background);
  }

  function initSplitSwatches(root = document) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.matches?.(SWATCH_SELECTOR)) applySplitSwatch(root);
    root.querySelectorAll?.(SWATCH_SELECTOR).forEach(applySplitSwatch);
  }

  initSplitSwatches();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach(initSplitSwatches);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
